import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {
  Field,
  reduxForm,
  formValueSelector,
  getFormSubmitErrors
} from 'redux-form';

import {required, validEmail} from 'utils/validators';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {TextField, CheckBoxField} from 'components/Fields';
import ErrorBlock from 'components/ErrorBlock';

import {selectModal} from 'ducks/modals';
import {MODALS, inviteNewStaffMember} from 'ducks/teams';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  let teams = _.get(values, 'teams');
  if (teams) {
    teams = props.teams.filter(t => _.get(teams, t.name, false)).map(t => t.id);
  }

  values = {...values, teams};

  dispatch(inviteNewStaffMember(values, props.submitExtraActions));
};

class InviteNewStaffMemberForm extends React.Component<any> {
  handleTeamRowClick = team => {
    const currentValue = _.get(this.props.selectedTeams, team.name, false);

    this.props.change(`teams.${team.name}`, !currentValue);
  };

  render() {
    const {teams, error, formErrors} = this.props;

    let teamsError = _.get(formErrors, 'teams');
    if (teamsError) {
      teamsError =
        'Cannot create staff member with no team. Choose at least one.';
    }

    return (
      <form
        className="InviteNewStaffMemberForm"
        onSubmit={this.props.handleSubmit}>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Name</Label>
          <Field
            name="name"
            component={TextField}
            placeholder="How do you want their name to appear?"
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>Email</Label>
          <Field
            name="email"
            component={TextField}
            placeholder="First letter then surname @thecollective.co.uk"
            validate={[required, validEmail]}
          />
        </FormField>
        <FormField>
          <Label>Job Title</Label>
          <Field
            name="jobTitle"
            component={TextField}
            placeholder="What is their job title within the company?"
            validate={[required]}
          />
        </FormField>

        <div className="teamsSection">
          <h3 className="header">Team</h3>
          {teamsError && <ErrorBlock>{teamsError}</ErrorBlock>}
          <div className="teamsList">
            {teams &&
              teams.map(team => (
                <Label
                  htmlFor={`teams.${team.name}`}
                  key={team.id}
                  className="teamRow colab-clickable"
                  onClick={() => this.handleTeamRowClick(team)}>
                  <div
                    className="image"
                    style={{backgroundImage: `url(${team.avatar})`}}
                  />
                  <div className="info">
                    <div className="name">{team.name}</div>
                    <div className="membersCount">{team.members.length}</div>
                  </div>
                  <Field
                    name={`teams.${team.name}`}
                    component={CheckBoxField}
                  />
                </Label>
              ))}
          </div>
        </div>
      </form>
    );
  }
}

const formSelector = formValueSelector('inviteNewStaffMember');
const mapStateToProps = state => {
  const {data: {teams}} = selectModal(state, MODALS.INVITE_NEW_STAFF_MEMBER);

  return {
    teams,
    selectedTeams: formSelector(state, 'teams'),
    formErrors: getFormSubmitErrors('inviteNewStaffMember')(state)
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'inviteNewStaffMember',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(InviteNewStaffMemberForm)
);
